import React from "react";
import classNames from "classnames";
import Icon from "../form/Icon";

class ContentLoader extends React.Component {

    constructor(props){
        super(props);
    }

    render() {
        if (this.props.children) {
            return (this.props.children);
        } else {
            // <Icon lib="fa" name="refresh" spin={true} className={classNames("fa-3x", this.props.className)}/>
            return (<div className="text-center content-loader">
                <i className="pi-spin pi pi-spinner" />
            </div>);
        }
    }
}

export default ContentLoader;